import React from 'react';

const RadioInput = props => (
  <input
    type="radio"
    id={props.inputId}
    name={`${props.groupName}[${props.name}]`}
    value={props.value}
    onChange={props.onChange}
    checked={props.checked}
    className={props.inputClassName} />
);

RadioInput.defaultProps = {
  groupName: 'parameters',
  name     : '',
  checked  : false,
};

export default RadioInput;
